import React from 'react';
import Navbar from '../components/Navbar';
import './SubPage.css';
import FooterAction from '../components/FooterAction';



export default function Merch() {
  return (
    <div className="subpage">
      <Navbar />

      <div className="merch-empty">
        <h2>No products</h2>
      </div>
        <FooterAction />
    </div>
  );
}